import { asyncCartridgeLoad } from '@/modules-es5/commons/lib/lib-lazyload';
import { init as initSelect } from '../../commons/select';

const ASYNC_FLOOR_ID = 'ReviewsFloor';
const NOTATION_LINKS = '.side-review.note-details a';
const CROSS_ACTION_CLASS = '.action-cross';
const REVIEW_PAGE_DATA = 'reviewPage';
const CARTRIDGE_REVIEW_PREFIX_ID = 'product-review-cartridge-';
const ORIGINAL_PRODUCT_REVIEW_ID = 'original-product-review-';
const PRODUCT_REVIEW_ID = 'product-review-id';
const PRODUCT_REVIEW_LIST_ID = 'product-reviews-list';
const LOAD_REVIEWS_SORTED_BY_MODEL = '#sortProdReviewsByModel li';

export function init() {
  const productReviewList = $('#product-reviews-list');

  // init Model dropdown
  initSelect();
  // Sort by model
  const selectModel = cube.$id('dkt-select-model-option');
  if (selectModel != null) {
    selectModel.addEventListener('change', () => {
      cube.event.send('sort-reviews');
    });
  }

  // Sort by type
  const selectSort = cube.$id('dkt-select-sort-option');
  if (selectSort != null) {
    selectSort.addEventListener('change', () => {
      cube.event.send('sort-reviews');
    });
  }

  // Sort by note
  cube.$$('#ReviewsFloor .notation-filter:not(.disabled)').on('click', e => {
    e.preventDefault();

    const target = e.currentTarget;
    if (target.closest('.js-panel-review-star')) {
      if (target.classList.contains('active')) {
        target.classList.remove('active');
      } else {
        if (target.closest('.notation-box').$('.notation-filter.active'))
          target
            .closest('.notation-box')
            .$('.notation-filter.active')
            .classList.remove('active');
        target.classList.add('active');
      }
    }

    cube.event.send('sort-reviews', e);
  });

  // Body review should be only collapsible in mobile version
  if (productReviewList.data(REVIEW_PAGE_DATA)) {
    $('.reviewBody').addClass('collapsible-mobile-only');
  }

  // Reload product review cartridge to translate it
  productReviewList.on('click', '.js-product-translate-button', function handleClick() {
    translateReview($(this), {}, reloadTranslateEvents);
  });

  // Reload product review cartridge to get original version
  productReviewList.on('click', '.js-product-original-button', function handleClick() {
    displayOriginalReview($(this));
  });

  cube.$$(NOTATION_LINKS).on('click', handleNotationClick);
  cube.$$(LOAD_REVIEWS_SORTED_BY_MODEL).on('click', handleModelClick);
  cube.$$(CROSS_ACTION_CLASS).on('click', handleRemoveNoteClick);

  // rebind collapse
  const floor = cube.$id(ASYNC_FLOOR_ID);

  if (floor.$('.title-floor')) {
    floor.$('.title-floor').on('click', () => {
      const isCollapsed = !floor.$('.floor-content-holder').classList.contains('in');
      const ariaValue = isCollapsed ? 'false' : 'true';
      const collapseValue = isCollapsed ? 'show' : 'hide';

      if (cube.ui.isMobile()) {
        $(floor.$('.floor-content-holder')).collapse(collapseValue);
        floor.$('.title-floor').setAttribute('aria-expanded', ariaValue);
      }
    });

    $(window).on('enter-small-screen', () => {
      $(floor.$('.floor-content-holder')).collapse('show');
      floor.$('.title-floor').setAttribute('aria-expanded', 'false');
    });
  }
}

export function addReviewsParamFromQuery(param) {
  // Check for the needed params in query parameters
  const queryParam = window.location.search
    .substring(1)
    .split('&')
    .find(e => e.startsWith(`${param}=`));

  // If the 'queryParams' exists and has a value :
  // add it in the 'data-params' of the floor
  const floorReviews = cube.$id(ASYNC_FLOOR_ID);
  if (queryParam && floorReviews) {
    const { params } = floorReviews.dataset;
    floorReviews.dataset.params = encodeURIComponent(`${decodeURIComponent(params)}&${queryParam}`);
  }
}

/**
 * When clicking on a 'notation' in the reviews, if we are on product-page
 * -- or if ReviewsFloor is loaded asynchronously (.async-container)
 * we change the 'data-params' of the cartridge and reload it >> no page redirection
 *
 * @param {Event} event
 */
function handleNotationClick(event) {
  event.preventDefault();

  const clickedElement = event.currentTarget;
  const floorReviews = cube.$id(ASYNC_FLOOR_ID);

  if (
    clickedElement.classList.contains('active') ||
    (clickedElement.closest('.notation-filter') &&
      clickedElement.closest('.notation-filter').classList.contains('active'))
  )
    return;

  if (floorReviews) {
    const notation =
      (clickedElement.closest('.notation-filter') && clickedElement.closest('.notation-filter').dataset.notation) ||
      clickedElement.$('.rate-text').innerText ||
      null;
    const params = new URLSearchParams(floorReviews.dataset.params);

    if (params.get('notes')) {
      params.set('notes', notation);
    } else {
      params.append('notes', notation);
    }

    floorReviews.dataset.params = params.toString();

    asyncCartridgeLoad(floorReviews, () => cube.ui.smoothScroll(floorReviews));
  }
}

/**
 * When clicking on a 'model' in the reviews, if we are on product-page
 * -- or if ReviewsFloor is loaded asynchronously (.async-container)
 * we change the 'data-params' of the cartridge and reload it >> no page redirection
 *
 * @param {Event} event
 */
function handleModelClick(event) {
  event.preventDefault();

  const clickedElement = event.currentTarget;
  const floorReviews = cube.$id(ASYNC_FLOOR_ID);

  if (floorReviews) {
    const params = new URLSearchParams(floorReviews.dataset.params);
    params.delete('notes');

    if (!params.get('offer')) {
      params.append('offer', clickedElement.closest(LOAD_REVIEWS_SORTED_BY_MODEL).dataset.model);
    }

    floorReviews.dataset.params = params.toString();

    asyncCartridgeLoad(floorReviews, () => cube.ui.smoothScroll(floorReviews));
  }
}

/**
 * When clicking on a 'cross' in the reviews, if we are on product-page
 * -- or if ReviewsFloor is loaded asynchronously (.async-container)
 * we change the 'data-params' of the cartridge and reload it >> no page redirection
 *
 * @param {Event} event
 */
function handleRemoveNoteClick(event) {
  event.preventDefault();
  event.stopPropagation();

  const clickedElement = event.currentTarget;
  const floorReviews = cube.$id(ASYNC_FLOOR_ID);

  if (!clickedElement.closest('.notation-filter').classList.contains('active')) {
    return;
  }

  if (floorReviews) {
    const params = new URLSearchParams(floorReviews.dataset.params);
    params.delete('notes');

    const queryParams = params.toString();

    if (floorReviews.classList.contains('all-reviews')) {
      Promise.all([
        new Promise(res =>
          cube
            .cartridge('ReviewsFloor')
            .after(res)
            .reload(encodeURIComponent(queryParams))
        ),
        new Promise(res =>
          cube
            .cartridge('ReviewsList')
            .after(res)
            .reload(encodeURIComponent(queryParams))
        ),
      ]).then(() => {
        init();
      });
    } else {
      floorReviews.dataset.params = params.toString();
      asyncCartridgeLoad(floorReviews, () => cube.ui.smoothScroll(floorReviews));
    }
  }
}

function translateReview($this, params, successCallBack) {
  const productReviewId = $this.data(PRODUCT_REVIEW_ID);
  const productReviewCid = CARTRIDGE_REVIEW_PREFIX_ID + productReviewId;
  params.productReviewId = productReviewId;
  window.reloadCartridgeContentCollection($(this), productReviewCid, params, () => {
    successCallBack(productReviewId);
  });
}

function reloadTranslateEvents(productReviewId) {
  toggleOriginalReview(productReviewId, false);
  reloadCommonEvents(productReviewId);
}

function reloadCommonEvents(productReviewId) {
  const productReviewCid = CARTRIDGE_REVIEW_PREFIX_ID + productReviewId;
  const reviewCartridge = $(`#${productReviewCid}`);
  const iframe = reviewCartridge.find('iframe');

  iframe.attr('src', iframe.data('url'));
  triggerReadMore();
  reviewCartridge.find('.translate-button').hide();
  reviewCartridge.find('.original-button').removeClass('hidden');
}

function toggleOriginalReview(productReviewId, isVisible) {
  const originalReviewCid = ORIGINAL_PRODUCT_REVIEW_ID + productReviewId;
  const originalReviewCartridge = $(`#${originalReviewCid}`);
  if (isVisible) {
    originalReviewCartridge.show();
    triggerReadMore();
  } else {
    originalReviewCartridge.hide();
  }
}

function displayOriginalReview($this) {
  const productReviewId = $this.data(PRODUCT_REVIEW_ID);
  const productReviewCid = CARTRIDGE_REVIEW_PREFIX_ID + productReviewId;
  $(`#${productReviewCid}`).empty();
  toggleOriginalReview(productReviewId, true);
}

function triggerReadMore() {
  const isReviewPage = $(`#${PRODUCT_REVIEW_LIST_ID}`).data(REVIEW_PAGE_DATA);
  if (!isReviewPage || $('body').hasClass('mobile')) {
    // Display need more if needed
    if ($('.collapsible:first').css('line-height') !== undefined) {
      window.UxCollapsibleText.setCollapsedHeight();
    } else {
      console.warn('Warning: window.UxCollapsibleText is undefined');
    }
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/product-review.js